import { isEmpty } from 'lodash';
import { IUser } from 'src/types';
import { GET_ME } from 'admin/constants/actions';
import { me as verifyEndpoint } from 'admin/resources';
import { createThunkAction } from 'admin/actions/helpers';
import { getResponseErrors } from 'common/resources/api-response';
import { logout } from './logout';

export interface GetMeResult {
	id: IUser['id'];
	paymentPlan: IUser['paymentPlan'];
	roles: IUser['roles'];
	verified: IUser['verified'];
	passwordUpdatedAt: Nullable<string>;
}

export const getMe = createThunkAction<GetMeResult>({
	type: GET_ME,
	skipAlert: true,
	onError: ({ error, dispatch }) => {
		const statusCode = getResponseErrors(error)?.[0]?.statusCode || error.status;
		if (statusCode === 401 || statusCode === 403) dispatch(logout());
	},
	payloadCreator: async () => {
		const response = await verifyEndpoint.send();
		const { result, success } = response.body;

		if (success && isEmpty(result)) {
			throw new Error('No user data');
		}

		return {
			...response.body,
			result: {
				id: result.id,
				paymentPlan: result.paymentPlan ?? null,
				roles: result.roles,
				verified: result.verified,
				passwordUpdatedAt: result.passwordUpdatedAt ?? null,
			},
		};
	},
});
